import { Outlet, useLocation } from "@tanstack/react-router";
import { motion } from "motion/react";
import { Footer } from "@/components/layout/footer.tsx";
import { Header } from "@/components/layout/header.tsx";

export function RootLayout() {
  const location = useLocation();

  return (
    <div className="relative h-screen overflow-hidden bg-background text-foreground">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(82,106,184,0.14),transparent_38%),radial-gradient(circle_at_bottom_left,rgba(255,170,140,0.04),transparent_26%)]" />
      <div className="relative grid h-full min-h-0 grid-rows-[auto_1fr_auto]">
        <Header />
        <main className="min-h-0 overflow-hidden">
          <motion.div
            key={location.pathname}
            className="h-full"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          >
            <Outlet />
          </motion.div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
